import { Component, Input, input, model, output } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { DividerModule } from "primeng/divider";
import { CardModule } from "primeng/card";
import { AvatarModule } from "primeng/avatar";
import { CommonModule, DatePipe } from "@angular/common";
import { IUser } from "../user.model";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { SelectModule } from "primeng/select";



@Component({
  selector: "app-user-view",
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    TagModule,
    DividerModule,
    CardModule,
    AvatarModule,
    DatePipe,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SelectModule
  ],
  templateUrl: "./user-view.component.html",
  styleUrl: "./user-view.component.css",
})
export class UserViewComponent {

  partner = input<IUser>();
  visible = model<boolean>(false);
  onClose = output();
  @Input() title: string = 'Default Title';
  @Input() data: any; // Example for passing an object
  isLoading = false;
  isSubmitting = false;
  isDeleting = false;
  isEditMode = false;
  currentApp: IUser = {
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    role: "cat",
  };

  myForm: FormGroup;

  roles: Array<string> = [
    "cat",
    "dog"
  ]

  constructor(private activeModal: NgbActiveModal, private fb: FormBuilder){
    this.myForm = this.fb.group({
      name: [''], // Initial value
      email: ['', Validators.email], // Initial value and validator
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    // console.log("App was saved");
    // console.log(this.myForm);
    //  if (this.myForm.valid) {
    //   console.log(this.myForm.value); // Access the form data
    //   // Perform actions with the form data
    // }
  }

  closeDialog(): void {
    this.onClose.emit();
  }

  closeModalFromInside() {
    this.activeModal.close('Data from inside modal');
  }

  dismissModalFromInside() {
    this.activeModal.dismiss('Reason from inside modal');
  }
}
